'use client';

/**
 * REACT_MEDIA_REGISTRY — `component_name` → React component for
 * media resources whose `kind` is `react_component`.
 *
 * Procedural / animated visuals that don't fit image/video/svg/lottie
 * land here. The media YAML names the component; this map resolves
 * the name to the actual React component. Renames are local — the
 * media YAML keeps its `component_name` value, only this map's import
 * needs updating.
 *
 * Adding a new component:
 *   1. Build the React component file (animated SVG, custom canvas, etc.)
 *   2. Import it here.
 *   3. Add the `component_name → component` entry below.
 *   4. Author the YAML entry in `media.yaml` with kind=react_component.
 *
 * @see klyde_edge/klyde_web_content/data/media.yaml — entries
 * @see media-renderer.tsx — dispatch site
 *
 * @layer presentation
 * @arch_component_type registry
 * @arch_domain media
 */

import type { ComponentType } from 'react';

import { KlydePlatformGraphic } from './klyde-platform-graphic';
import { FoundationChainDiagram } from './foundation-chain-diagram';

export const REACT_MEDIA_REGISTRY: Record<string, ComponentType> = {
  // Stripe-style animated flow diagram — five sources flow through
  // the central Klyde hub to outputs, with particles tracing the
  // SVG paths in real time.
  KlydePlatformGraphic,
  // Static connected-record chain — Requirement -> Product -> Vendor ->
  // Response -> Order. No animation; legibility of the chain is the job.
  FoundationChainDiagram,
};
